import yup from '../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getForgotPasswordFormValidation(t: TFunction) {
  return yup.object({
    email: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .email(t('formikValidation.emailCorrect'))
      .required(t('formikValidation.emailRequired')),
  });
}
